import { Button } from '@shared/components';

export function Auth0LoginButton() {
  return (
    <div className="mt-4 flex w-full flex-wrap text-gray-700">
      <Button onPress={displayAuth0Login} className="w-full">
        Sign in another way
      </Button>
    </div>
  );
}

const displayAuth0Login = () => {
  window.parent.postMessage(
    { op: 'INITIATE_AUTH_FLOW' },
    'https://mail.google.com'
  );
};
